// extracted by mini-css-extract-plugin
module.exports = {"hidden":"animations_hidden__Ujlex","spinIn":"animations_spinIn__Gmr63","spinOut":"animations_spinOut__tA1o_"};